<div class="gc-case-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'selection' | translate: ['tmc.visit.overview.gc-case-dialog.title', translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.name"
        [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <div class="layout">
        <div class="qr-code-box">
          <qrcode *ngIf="data.qrCodeUrl" [qrdata]="data.qrCodeUrl" [scale]="6" [errorCorrectionLevel]="'M'"></qrcode>
        </div>
        <div [formGroup]="detailsFormGroup" *ngIf="dynamicDisplayEnabled" class="action">
          <mat-checkbox name="updateDisplayAutomatically" formControlName="updateDisplayAutomatically">
            {{'update display automatically' | translate:
            ['tmc.visit.overview.gc-case-dialog.update-display-automatically', translationService.language]}}
          </mat-checkbox>
          <button class="activate-display-button" mat-stroked-button (click)="activateGlobalConnectDisplayAction()">
            {{'activate display now'|
            translate:['tmc.visit.overview.gc-case-dialog.action.activate-display-now',translationService.language]}}
          </button>
        </div>
      </div>
    </div>

    <i class="horizontal-divider"></i>
    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button [mat-dialog-close]="true" cdkFocusInitial>{{'close' | translate:
        ['tmc.visit.overview.gc-case-dialog.action.close', translationService.language]}}</button>
    </sc-actionbar>

  </div>
</div>
